import { Link } from 'react-router-dom';
import Icon, { type IconName } from './Icon';

interface ResourceCardProps {
  icon: IconName;
  title: string;
  description: string;
  to?: string;
  onClick?: () => void;
}

export default function ResourceCard({ icon, title, description, to, onClick }: ResourceCardProps) {
  const inner = (
    <>
      <div className="flex items-center justify-between">
        <Icon name={icon} className="h-6 w-6 text-primary/70" />
        <Icon name="arrow" className="h-4 w-4 text-primary opacity-0 transition-all group-hover:translate-x-1 group-hover:opacity-100" />
      </div>
      <h3 className="mt-6 text-lg font-semibold text-text-primary">{title}</h3>
      <p className="mt-1.5 text-sm leading-6 text-text-secondary">{description}</p>
    </>
  );

  const classes = 'group flex flex-col border-t border-ink/15 pt-6 text-left transition-colors hover:border-primary';

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={classes}>
        {inner}
      </button>
    );
  }
  return (
    <Link to={to ?? '#'} className={classes}>
      {inner}
    </Link>
  );
}
